export default __webpack_public_path__ + "static/media/emptyTimeline.5badb561.png";